import * as tslib_1 from "tslib";
import { ClientErrorCodes, } from '@models';
var TranslatableError = /** @class */ (function (_super) {
    tslib_1.__extends(TranslatableError, _super);
    function TranslatableError(translationKey, supportCode) {
        var _newTarget = this.constructor;
        if (supportCode === void 0) { supportCode = ClientErrorCodes.UnknownUiError; }
        var _this = 
        // 'Error' breaks prototype chain here.
        _super.call(this, translationKey + " (#" + supportCode + ")") || this;
        _this.translationKey = translationKey;
        _this.supportCode = supportCode;
        // Restore prototype chain.
        Object.setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return TranslatableError;
}(Error));
export { TranslatableError };
